"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GASv3 = void 0;
var _analyticsNext = require("@atlaskit/analytics-next");
var _analyticsWebClient = require("@atlassiansox/analytics-web-client");
var _cookie = require("../../utils/cookie");
var _analyticsState = require("./analytics-state");
var _guid = require("../../utils/guid");
var _helpers = require("./helpers");
var _identity = require("./identity");
var _tracking = require("./tracking");
var _trelloUrlScrubber = require("./trello-url-scrubber");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var queryString = require('query-string');
var attributeWhiteList = ['atlCohort', 'featureFlags'];
var ATL_USER_HASH = 'atlUserHash';
/**
 * Module for GASv3 tracking events.
 * @module GASv3
 */
var GASv3 = exports.GASv3 = /*#__PURE__*/function () {
  function GASv3() {
    _classCallCheck(this, GASv3);
  }
  return _createClass(GASv3, null, [{
    key: "sendUIEvent",
    value:
    /**
     * Sends a UI event to GASv3
     * @function sendUIEvent
     * @param {string} name
     * @param {object} data
     * @param {object} skipEnrichment - whether to add additional data
     */
    function sendUIEvent(name, data, skipEnrichment) {
      var attributes = data.attributes || {};
      if (!skipEnrichment) {
        attributes = GASv3.enrichEventData(data.attributes);
      }
      attributes['trackEventName'] = name;
      var source = GASv3.setSource(data);
      var uiEvent = {
        action: data.action || 'clicked',
        actionSubject: data.actionSubject || 'component',
        actionSubjectId: data.actionSubjectId || undefined,
        source: source,
        attributes: attributes
      };
      this._createAndFireEvent(_analyticsWebClient.eventType.UI, uiEvent);
    }

    /**
     * Sends a Screen event to GASv3
     * @function sendScreenEvent
     * @param {string} name
     * @param {object} data - GASv3 screen event attributes
     *                 data.screenNameOverride - special data attribute that overrides the screen name for the event, instead of the default 'page'.
     *                                           If used, this attribute will be stripped from the data before sending to GASv3.
     * @param {object} skipEnrichment - whether to add additional data
     */
  }, {
    key: "sendScreenEvent",
    value: function sendScreenEvent(name, data, skipEnrichment) {
      var attributes = data.attributes || {};
      if (!skipEnrichment) {
        attributes = GASv3.enrichEventData(data.attributes);
      }
      attributes['name'] = name || data['name'];
      var screenName = data['name'] || attributes['screenNameOverride'] || 'page';
      delete attributes['screenNameOverride'];
      this._createAndFireEvent(_analyticsWebClient.eventType.SCREEN, {
        name: screenName,
        attributes: attributes
      });
      GASv3.sendIdentityEvent();
    }

    /**
     * Sends a track event to GASv3
     * NOTE: Track events are not supported by the original marketing atl-analytics wrapper
     * @param name
     * @param data
     * @param skipEnrichment
     */
  }, {
    key: "sendTrackEvent",
    value: function sendTrackEvent(name, data, skipEnrichment) {
      var attributes = data.attributes || {};
      if (!skipEnrichment) {
        attributes = GASv3.enrichEventData(data.attributes);
      }
      attributes['trackEventName'] = name;
      data.source = GASv3.setSource(data);
      data.attributes = attributes;
      this._createAndFireEvent(_analyticsWebClient.eventType.TRACK, data);
    }

    /**
     * Sends an operational event to GASv3
     * NOTE: Operational events are not supported by the original marketing atl-analytics wrapper
     * @param name
     * @param data
     * @param skipEnrichment
     */
  }, {
    key: "sendOperationalEvent",
    value: function sendOperationalEvent(name, data, skipEnrichment) {
      var attributes = data.attributes || {};
      if (!skipEnrichment) {
        attributes = GASv3.enrichEventData(data.attributes);
      }
      attributes['trackEventName'] = name;
      data.source = GASv3.setSource(data);
      data.attributes = attributes;
      this._createAndFireEvent(_analyticsWebClient.eventType.OPERATIONAL, data);
    }

    /**
     * Sends a 'user identified' GASv3 event if the user hash has changed
     * @function sendIdentityEvent
     */
  }, {
    key: "sendIdentityEvent",
    value: function sendIdentityEvent() {
      // load the identity hash cookie
      var atlUserHash = _cookie.Cookie.readCookie(ATL_USER_HASH);
      // get the user identifiers
      var identifiers = GASv3.getUserIdentifiers();
      // calculate the data hash of the known identifiers
      var calculatedHash = _guid.Guid.guidHashCode(JSON.stringify(identifiers)).toString();
      if (!atlUserHash || atlUserHash !== calculatedHash) {
        // save new hash and send UI event
        _cookie.Cookie.writeCookie(ATL_USER_HASH, calculatedHash, 3650, true);
        var data = {
          action: 'identified',
          actionSubject: 'user',
          identifiers: identifiers,
          writeKey: _analyticsState.AnalyticsState.writeKey
        };
        GASv3.sendUIEvent('', data, true);
      }
    }
  }, {
    key: "getUserIdentifiers",
    value: function getUserIdentifiers() {
      return {
        anonymousId: _analyticsState.AnalyticsState.anonymousId,
        atlassianAccountId: _identity.Identity.getAtlassianUserId(),
        crossDomainId: _tracking.Tracking.xid,
        optimizelyEndUserId: null,
        trelloUserId: _identity.Identity.getTrelloUserId()
      };
    }
  }, {
    key: "setSource",
    value: function setSource(data) {
      var set = false;
      var source = data.source || '';
      if (source) {
        set = true;
      }
      if (data['eventContainer']) {
        source += data['eventContainer'].split(' ')[0];
        set = true;
      }
      if (data['eventColumn']) {
        source += data['eventColumn'].split(' ')[0];
        set = true;
      }
      if (!set) {
        source = 'none';
      }
      return source;
    }

    // fix for hot-99118
  }, {
    key: "getReferrerURL",
    value: function getReferrerURL(ref) {
      if (_identity.Identity.isReferrerTrello()) {
        var referrer = new URL(ref);
        return referrer.hostname + _trelloUrlScrubber.TrelloUrlScrubber.scrubUrl(referrer.pathname, '');
      }
      return ref;
    }
  }, {
    key: "_createAndFireEvent",
    value: function _createAndFireEvent(eventType, payload) {
      // using analytics-next createAndFireEvent to send event
      if (_analyticsState.AnalyticsState.createAnalyticsEvent) {
        (0, _analyticsNext.createAndFireEvent)('atl-global')(_objectSpread(_objectSpread({}, payload), {}, {
          eventType: eventType
        }))(_analyticsState.AnalyticsState.createAnalyticsEvent);
      }

      // using analytics-web-client to send event
      if (GASv3.client) {
        switch (eventType) {
          case 'ui':
            GASv3.client.sendUIEvent(payload, null);
            break;
          case 'screen':
            GASv3.client.sendScreenEvent(payload, null);
            break;
          case 'operational':
            GASv3.client.sendOperationalEvent(payload, null);
            break;
          case 'track':
            GASv3.client.sendTrackEvent(payload, null);
            break;
        }
      }
    }
  }, {
    key: "enrichEventData",
    value: function enrichEventData(inputData) {
      var data = {};
      if (_typeof(inputData) !== 'object' || inputData === null) {
        var dataValue = inputData;
        if (typeof dataValue !== 'undefined') {
          data.data = dataValue;
        }
      } else {
        data = inputData;
      }
      var newData = JSON.parse(JSON.stringify(data));
      newData.writeKey = _analyticsState.AnalyticsState.writeKey;
      newData.isMarketingEvent = GASv3.isMarketingEvent;
      var page;
      var ref;
      var page_canonical_url;
      try {
        var _page;
        // convert all passed in values to string if they are currently objects
        Object.keys(newData).forEach(function (inputKey) {
          var key = inputKey;
          if (newData[key] && _typeof(newData[key]) === 'object' && !Array.isArray(newData[key]) && !attributeWhiteList.includes(key)) {
            // @ts-ignore
            newData[key] = JSON.stringify(newData[key]);
          }
        });
        var href = GASv3.getLocation();
        page = href ? new URL(_helpers.Helpers.maskURL(href)) : null;
        var referredByJiraDotCom = ((_page = page) === null || _page === void 0 ? void 0 : _page.searchParams.get('referer')) === 'jira.com';
        ref = referredByJiraDotCom ? new URL('https://www.jira.com') : document.referrer ? new URL(_helpers.Helpers.maskURL(document.referrer)) : null;
        var canonical_url = _helpers.Helpers.getCanonicalUrl();
        page_canonical_url = canonical_url ? _helpers.Helpers.maskURL(_helpers.Helpers.getCanonicalUrl()) : undefined;
        newData.page_title = newData.page_title || document.title || '';
        newData.page_domain = page ? page.hostname || '' : '';
        newData.page_subdomain = page ? page.hostname || '' : '';

        // referrer attributes
        newData.page_referrer_domain = ref ? ref.hostname || '' : '';
        newData.page_referrer_subdomain = ref ? ref.hostname || '' : '';
        if (_identity.Identity.isReferrerTrello()) {
          // fix for hot-99118
          newData.page_canonical_url = page ? _trelloUrlScrubber.TrelloUrlScrubber.scrubUrl(page.href, page.origin) || '' : '';
          newData.page_url = page ? _trelloUrlScrubber.TrelloUrlScrubber.scrubUrl(page.href, page.origin) || '' : '';
          newData.page_path = page ? _trelloUrlScrubber.TrelloUrlScrubber.scrubUrl(page.pathname, new URL(page.href).pathname) || '' : '';
          newData.page_url_parameters = page ? _trelloUrlScrubber.TrelloUrlScrubber.scrubUrl(page.search, '') : '';
          newData.page_url_params_json = page ? JSON.stringify(queryString.parse(_trelloUrlScrubber.TrelloUrlScrubber.scrubUrl(page.search, new URL(page.origin).pathname))) : '';
          newData.page_referrer_url_params_json = ref ? JSON.stringify(queryString.parse(_trelloUrlScrubber.TrelloUrlScrubber.scrubUrl(ref.search, new URL(ref.origin).pathname))) : '';
          newData.page_referrer_path = ref ? _trelloUrlScrubber.TrelloUrlScrubber.scrubUrl(ref.pathname, new URL(ref.origin).pathname) || '' : '';
          newData.page_referrer_url = ref ? ref.origin + _trelloUrlScrubber.TrelloUrlScrubber.scrubUrl(ref.pathname, new URL(ref.origin).pathname) || '' : '';
        } else {
          newData.page_canonical_url = page_canonical_url;
          newData.page_url = page ? page.href || '' : '';
          newData.page_path = page ? page.pathname || '' : '';
          newData.page_url_parameters = page ? page.search || '' : '';
          newData.page_url_params_json = page ? JSON.stringify(queryString.parse(page.search)) : '';
          newData.page_url_fragment = page ? _helpers.Helpers.getUrlFragment() : ''; // added for community client
          newData.page_referrer_url_params_json = ref ? JSON.stringify(queryString.parse(ref.search)) : '';
          newData.page_referrer_path = ref ? ref.pathname || '' : '';
          newData.page_referrer_url = ref ? ref.href || '' : '';
        }
        newData.cookiesEnabled = window.navigator ? window.navigator.cookieEnabled : 'unknown';
        newData.activeGroups = window.OnetrustActiveGroups ? window.OnetrustActiveGroups : '';

        // add additionalEventData
        for (var _key in GASv3.additionalEventData) {
          // eslint-disable-next-line no-prototype-builtins
          if (GASv3.additionalEventData.hasOwnProperty(_key)) {
            newData[_key] = GASv3.additionalEventData[_key];
          }
        }
      } catch (e) {
        // fix for hot-99118
        var additionalData = {
          error: e instanceof Error ? e.message : JSON.stringify(e),
          href: location ? location.href : 'no location',
          referrer: document ? document.referrer ? GASv3.getReferrerURL(document.referrer) : 'no referrer' : 'no document'
        };
        _helpers.Helpers.sendWrapperLoadError('GASv3 enrichEventData error', JSON.stringify(additionalData));
      }
      return newData;
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      return location.href;
    }
  }]);
}();
// set this value with attributes that should be sent on every event, set during event enrichment
_defineProperty(GASv3, "additionalEventData", {});